// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import ReactGA from "react-ga4";

var generalCommonJS = require("../../js/generalCommon.js")

const PublicMainHeader = (params) => {

  useEffect(() => {    
    console.log("Cabecera pública cargada correctamente.")   

    const body = document.querySelector('body');
    const menuTrigger = document.querySelector('.menu-trigger .button.icon-only');
    const closeMenu = document.querySelector('.submenu .close-submenu');

    menuTrigger.onclick = function(e){
      body.classList.toggle('menu-open');
    };

    closeMenu.onclick = function(e){
      body.classList.toggle('menu-open');
    };

  });

  return (     
    <div id="headerPublico" className="masthead hidden">
      <header  className="wrapper">


        <nav className="inner-wrapper">
          <ul>
            <li className="brand"><a className="logo" href="https://www.fevergy.com" onClick={() => generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'INICIO', "", "")}><img loading="lazy" src="https://fevergy.com/images/brand.svg" alt="Fevergy Logo"/></a></li>
            <li className="menu">
              <ul>
                <li className="menu-trigger"><span className="button icon-only"><span className="material-icon size-l">menu</span></span></li>
                <li className="submenu-wrapper">
                  <ul className="submenu">
                    <li className="close-submenu"><span className="material-icon size-l">close</span></li>
                    <li className="submenu-item"><a className="button secondary" href="https://www.fevergy.com" onClick={() => generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'INICIO', "", "")}><span className="material-icon">home</span>Inicio</a></li>
                    <li className="submenu-item">
                      <span className="button secondary"><span className="material-icon">fact_check</span>SERVICIOS</span>
                      <ul className="submenu">
                        <li className="submenu-item"><a className="button secondary" href="https://www.fevergy.com/Helias" onClick={() => generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'HELIAS', "", "")}><span className="material-icon">play_arrow</span>Helias</a></li>
                        <li className="submenu-item"><a className="button secondary" href="https://www.fevergy.com/12-Facturas" onClick={() => generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', '12 FACTURAS', "", "")}><span className="material-icon">play_arrow</span>12 Facturas</a></li>                        
                        <li className="submenu-item"><a className="button secondary" href="https://helias.fevergy.com/Asesoramiento" onClick={() => generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'ASESORAMIENTO', "", "")}><span className="material-icon">play_arrow</span>Asesoramiento</a></li>
                      </ul>
                    </li>
                    <li className="submenu-item"><a className="button secondary" href="https://www.fevergy.com/Contacto" onClick={() => generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'CONTACTO', "", "")}><span className="material-icon">email</span>Contacto</a></li>


                    <li className="submenu-item social">
                      <ul>
                        <li><a href="https://blog.fevergy.com/" title="Blog" onClick={() => generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'BLOG', "", "")} target="_blank"><img src="https://fevergy.com/images/blogger.svg" alt="Blog" width="20"/></a></li>                        
                        <li><a href="https://www.instagram.com/fevergy_systems/" title="Instagram" onClick={() => generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'INSTAGRAM', "", "")} target="_blank"><img src="https://fevergy.com/images/instagram.svg" alt="Instagram" width="20"/></a></li>
                        <li><a href="https://www.facebook.com/fevergy/" title="Facebook" onClick={() => generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'FACEBOOK', "", "")} target="_blank"><img src="https://fevergy.com/images/facebook.svg" alt="Facebook" width="20"/></a></li>
                        <li><a href="https://www.youtube.com/channel/UCbH7D7-HFefLQQqLQ6sSFZw" title="YouTube" onClick={() => generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'YOUTUBE', "", "")} target="_blank"><img src="https://fevergy.com/images/youtube.svg" alt="YouTube" width="20"/></a></li>
                        <li><a href="https://www.linkedin.com/company/fevergy" title="LinkedIn" onClick={() => generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'LINKEDIN', "", "")} target="_blank"><img src="https://fevergy.com/images/linkedin.svg" alt="LinkedIn" width="20"/></a></li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

          </ul>
        </nav>

      </header>

      <div id="cabeceraAsesoramientoPublico" className="wrapper">
        <div className="inner-wrapper">
          <div className="main text-center">
            <h1>Asesoramiento</h1>
            <p className="size-l">Aquí tienes una serie de recomendaciones y herramientas gratuitas para lograr la mayor eficiencia y ahorro.</p>
          </div>
        </div>
      </div>
        
    </div>
  )
}

export default PublicMainHeader